import AuthService from '@/services/authService.ts';
import { computed } from 'vue';

export function useOnboarding() {
  const baseUrl = computed(() => {
    return `${window.location.origin}${window.location.pathname}`;
  });

  async function logoutAndOpenRegisterPage(
    redirectUrl: string,
    email: string | undefined
  ) {
    const encodedRedirectUrl = redirectUrl.startsWith(baseUrl.value)
      ? redirectUrl
      : window.location.origin + redirectUrl;

    await AuthService.logoutAndRegister({
      redirectUri: encodedRedirectUrl,
      loginHint: email,
      prompt: 'force_login_hint'
    });
  }

  async function openRegisterPage(
    redirectUrl: string,
    email: string | undefined
  ) {
    const encodedRedirectUrl = redirectUrl.startsWith(baseUrl.value)
      ? redirectUrl
      : window.location.origin + redirectUrl;

    await AuthService.register({
      redirectUri: encodedRedirectUrl,
      loginHint: email,
      prompt: 'force_login_hint'
    });
  }

  return {
    openRegisterPage,
    logoutAndOpenRegisterPage
  };
}
